export class PagedList<T>
    {
        public Source: T[];
        public PageIndex: number;
        public PageSize: number;
        public TotalRows: number;
        public TotalPages: number;
        public HasPreviousPage: Boolean;
        public HasNextPage: Boolean;
    }